import React from "react";
import Footer from "../Footer.js";
import './uniqueclasses.css'
import ReactGA from 'react-ga4';
import Sup from './Media/multisup.JPG'
import Pic1 from './Media/egyesület.jpg'
import Pic2 from './Media/egyesület3.jpg'
import Pic3 from './Media/egyesület4.JPG'
import programfuzet from './Media/programfuzet.jpg'

ReactGA.send({ hitType: "pageview", page: "/egyesulet", title: "Egyesulet" });

function Egyesulet() {
  
  return (
    <div>
            
            <div className="book-main-container"> 

<div className="unique-class-title-lia egyesuletpic">
<div className="unique-class-title-left">

<h1>Egyesület</h1>
<p className="title-short-desc">Csatlakozz a Lia Fit Sportegyesülethez és légy része egy támogató közösségnek!</p>


<div className="personal-data-lia">
        <a href = "mailto:info@liafit.hu">info@liafit.hu</a>
        <a href="tel:+36703836041">+36 70 383 6041</a>
    </div>
</div>
</div>


        <div className="container">
          <div className="inside-container">
 

<div className="class-description">




<div className="class-description-text">
<h2 className="class-description-h2">Miért éri meg csatlakozni?</h2>

<ul>
  <li>Éves tagsággal bizonyos programokon ingyenesen, másokon pedig kedvezményesen vehetsz
részt.</li>
   <li>Csoportos jógaórákra kedvezményes bérlet vásárlási lehetőség.</li>
    <li>Együtt kirándulunk, fejlődünk és motiváljuk egymást.</li>
     <li>Része lehetsz egy közösségnek, ahol számítasz.</li>
      <li>Ráadásul támogatásod és lelkesedésed az év végén megjutalmazzuk.</li>
</ul>

<h2 className="class-description-h2">Részletek</h2>

<ul>
  <li>2025-ben izgalmasabbnál izgalmasabb programokkal várunk! Minden hónapban új élményekkel
gazdagodhatsz - legyen szó kirándulásról, jógáról, vagy közösségi eseményekről.</li>
   <li>Tagként az események több, mint felén ingyen részt vehetsz! A többi programunkra pedig jelentős
kedvezményeket biztosítunk.</li>
    <li>Nézd meg a teljes programlistát!</li>
     <li>Egyesületi tagként Lia csoportos jóga órái továbbra is a megszokott 3.000 Ft / alkalom áron érhető el
egész évben, ha bérlettel veszel részt.<br></br>(Aktuális alkalmi áraink nem egyesületi tagoknak a „foglalás” menüpont alatt)</li>
      <li>5 alkalmas bérlet (érvényes 4 hétig) - 15.000 Ft
Többen is használhatják - családtagok, barátok együtt is vehetik!</li>
<li>Az évzáró programunkon értékes ajándékokat adunk mindazoknak, aki(k) a legtöbb jógabérletet járja le;</li>
<li>Szeretnénk megköszönni a részvételed és lelkesedésed: minél aktívabb vagy, annál több
esélyed van a különleges ajándékokra!</li>
</ul>

<h2 className="class-description-h2">Az „Évzáró bulinkon” (Időpont: 2025.dec.13.) értékes ajándékokat adunk mindazoknak, aki(k)</h2>

<ul>
<li>A legtöbb egyesületi programon vesz részt;  </li>
<li>A legtöbb jógabérletet járja le;</li>
<li>Ha rád mindkettő igaz lesz, téged külön jutalmazunk.</li>
<li>Az évzáró bulin extra tombolára jogosultak az egyesületi tagok. (Azon felül, hogy minden
„évzáró bulin” résztvevő kap egy tombolát)</li>
<h3>
  Az értékelés 2025. április 07. és december 10. közötti időszakra szól.
</h3>

<h3>
  Az ajándékok listája a teljesség igénye nélkül: komplex állapotfelmérések, BalanceTestek, jógabérletek,
ajándékutalványok a 2026-os programjainkra, valamint egyéb meglepetés ajándékok és utalványok.
</h3>
</ul>

</div>

<div className="class-description-pictures">
<img src={Pic1}/>
<img src={Pic2}/>
<img src={Pic3}/>

</div>

</div>

<img src={programfuzet} alt="Programfüzet" className="programfuzet" />
<p className="egyesulet-join">A programokról részletes leírást a weboldalunkon keresztül az "események" és a "foglalás" menüpontok alatt találsz.</p>

<div className="egyesuletpluszinfo">
<div className="egyesulet-gift">
  <h2>Egy ajándék a belépésed mellé!</h2>
  <p>Minden új egyesületi tagnak egy általam nevelt bio aloe vera palántát adok ajándékba! Az aloe vera egy igazi
csodanövény: segíti a bőr regenerálódását, erősíti az immunrendszert, ájurvédikus gyógyhatású, és tisztítja a
levegőt is. A jóga belső harmóniáját így a természet erejével is támogathatod otthonodban.</p> 
</div>

<div className="egyesulet-price">
  <h2>Mennyibe kerül? Hogyan lehetsz tag?</h2>
  <p>Tagdíj: mindössze 25.000 Ft/év, és cserébe akár 50.000 Ft értékű kedvezménnyel -csak a programokból + még
ezen felül a jógabérletek kedvezményei, év végi tombola és ajándékok értékei- és egy fantasztikus közösség
élményével gazdagodhatsz és egész évben élvezheted a fenti előnyöket!</p> 
</div>

<p className="egyesulet-shirt">
  Szeretnéd, hogy minden közös élményünkön a csapatunkat erősítsd? Jelentkezéskor kérd
a limitált kiadású, egyesületi grafikás pólónkat, és viseld büszkén a Lia Fit közösség
színeit!
</p>

<p className="egyesulet-join">
  Ha szeretnél egy támogató, inspiráló közösséghez tartozni, csatlakozz most!
</p>
<p className="egyesulet-join">
  <i>A jelentkezéshez kattints a gombra és töltsd ki a jelentkezési űrlapot.</i>
</p>


<section className="link-to-patreon margiine">
  <a href="https://docs.google.com/forms/d/e/1FAIpQLSeDZPGMt0f-9gzLdv2tOFf2zXRBUkUm_6K6c4XXWItHudQD7w/viewform?usp=sharing" target="_blank" rel="noopener noreferrer">
    <div>
      <h1>TAG SZERETNÉK LENNI</h1>
      <h2>Jelentkezem most!</h2>
    </div>
  </a>
</section>
<h2 className="varunk-szeretettel">Várunk szeretettel; Lia Fit SE</h2>



<div className="egyesulet-join-notsure">
  <p>Ezek után sem vagy még biztos? Próbáld ki csoportos és egyéni óráink, gyere el bármelyik
programunkra!
A tagság nem kötelező, az összes programunk, óráink, egyéb szolgáltatásaink mindenki számára nyitottak.</p>
</div>

<div className="introduction">

<div  className="know-more">
<h1>Tudj meg többet a céljainkról és küldetésünkről!</h1>
<h2>1. A sportegyesület célja:</h2>
<p>A sportegyesület célja az egészséges életmód, testi fitnesz és mentális ellenállóképesség elősegítése, és egy
olyan közösség létrehozása, amely ezt támogatja. Elkötelezettek vagyunk abban, hogy széleskörű
szolgáltatásokat nyújtsunk, amelyek célja az emberek életminőségének javítása. Átfogó megközelítésünk
magában foglalja a jógát, sportrehabilitációt, szabadidős tevékenységek szervezését, emberi kineziológiát,
egészségmegőrzést és sérülésmegelőzést.</p>

<h2>2. A sportegyesület tevékenysége:</h2>
<p>1. Fizikai és Mentális Jóllét Promotálása</p>

<ul>
  <li>Emberek inspirálása a testi és mentális egyensúly elérésére a jóga gyakorlásával.</li>
  <li>Rehabilitációs szolgáltatások nyújtása a sérülések gyógyulásának támogatására és az általános
fizikai erőnlét javítására</li>
  <li>Szabadidős tevékenységek szervezése, amelyek szórakozást és fitneszt kínálnak
minden korosztálynak.</li>

</ul>

<p>2. Emberi kineziológia és egészségtudományok fejlesztése</p>

<ul>
  <li>Kutatások folytatása és tudás megosztása az Emberi Kineziológia területén a fizikai teljesítmény
és jóllét javítása érdekében</li>
  <li>Egészségmegőrzés népszerűsítése oktatási programok, szemináriumok és információs források
révén.</li>

</ul>

<p>3. Sérülésmegelőzés és fenntartható egészség</p>

<ul>
  <li>Stratégiák és programok kidolgozása sérülések megelőzésére, különösen a sportok és testmozgás
során.</li>
  <li>Az egészség proaktív megközelítésének elősegítése, hangsúlyozva a sérülésmegelőzést és az
egészséges életmód fenntartását.</li>

</ul>

<p>4. Élő közösség kialakítása</p>

<ul>
  <li>Egy olyan élő közösség létrehozása, amelyben hasonló érdeklődésű emberek találkozhatnak, és
akik szenvedélyt éreznek a fitnesz, az egészség és a wellness iránt.</li>
  <li>Támogató környezet kialakítása, ahol a tagok kapcsolatot teremthetnek, tanulhatnak és együtt
fejlődhetnek.</li>

</ul>

<p>5. Az Egyének inspirálása</p>

<ul>
  <li>Személyre szabott fitnesztervek és edzési szolgáltatások nyújtása az egyének egészség- és
fitneszcéljainak eléréséhez.</li>
    <li>Az egyéneket arra ösztönözni, hogy vállalják a felelősséget a saját jóllétükért, eszközöket és
forrásokat kínálva a személyes fejlődéshez.</li>

</ul>

<p>6. Szolgáltatások kiválósága</p>

<ul>
  <li>Az igényesség elérése minden olyan szolgáltatásunkban, amelyeket kínálunk, biztosítva, hogy
tagjaink a legmagasabb minőségű ellátást és támogatást kapják.</li>
    <li>Folyamatosan fejleszteni szolgáltatásainkat visszajelzések és innováció révén.</li>

</ul>

<p>7. Fenntartható jövő kialakítása</p>

<ul>
  <li>Ökológiai szempontból fenntartható gyakorlatok népszerűsítése minden működési területünkön
annak érdekében, hogy hozzájáruljunk egy egészségesebb bolygóhoz.</li>
    <li>Fenntartható fitnesz- és wellness gyakorlatok támogatása.</li>
</ul>

</div>
</div>
</div>

  </div>      
</div>
      </div>
      <Footer />
    </div>
  );
}

export default Egyesulet;